import { useState } from "react";
import PropTypes from "prop-types";

import { useParentCollections } from "../../api/benchmarking/BenchmarkCollectionsAPI";
import { columns } from "./BenchmarkCollectionView.functions";
import Table from "../table/Table";

import Spinner from "../common/Spinner";
import isEmpty from "../../validation/is-empty";

import "./BenchmarkCollectionView.css";

BenchmarkCollectionView.propTypes = {
  rowData: PropTypes.object,
};
export default function BenchmarkCollectionView(props) {
  const { rowData } = props;

  const benchmarkId = rowData?.id;
  const projectName = rowData?.project_name;

  const { parentCollections } = useParentCollections(benchmarkId);

  const [selectedRow, setSelectedRow] = useState({});
  const [modal, setModal] = useState({});

  if (parentCollections.loading) {
    return <Spinner />;
  }

  if (isEmpty(parentCollections.data.data)) {
    return (
      <div className="no-data-available">
        <i className="fas fa-thumbs-down" /> Not included in any Collections
      </div>
    );
  }

  const displayData = [];

  parentCollections.data.data.forEach((parent, i) => {
    displayData.push({
      project_name: "Collection " + (i + 1) + ": " + parent.project_name,
      project_type: "",
      sector: "",
      sub_sector: "",
      quality: "",
      standard: "",
      tableRowType: "SUBHEADING",
    });

    parent.benchmarkComparisons?.forEach((child) => {
      const childObject = {
        project_name: child.project_name,
        project_type: child.project_type,
        sector: child.sector,
        sub_sector: child.sub_sector,
        quality: child.quality,
        standard: child.standard,
      };

      if (child.id === benchmarkId) {
        childObject.tableRowType = "SUBTOTAL";
      }

      displayData.push(childObject);
    });
  });

  return (
    <div className="collections-table-container">
      <div className="collections-table">
        <Table
          title={"Collections including " + projectName}
          tableArray={displayData}
          columns={columns()}
          tableSize={15}
          isTotalDisabled={true}
          isFilterDisabled={true}
          // Row Selection
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          // Modal Control
          setModal={setModal}
          modal={modal}
        />
      </div>
    </div>
  );
}
